import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthService from '../services/auth.service';

var authService = new AuthService();

export const AdminRoute = ({ component: Component, children: Children, ...rest }) => {
    let Element = Children ? Children : Component;
    let child = (props) => (
        authService.isAuthenticated() && authService.isAdmin() ? <Element {...props} />
            : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
    );
    return Children ? <Route {...rest} children={child} /> : <Route {...rest} render={child} />
};


// WEBPACK FOOTER //
// ./src/components/AdminRoute.js